import React from 'react';

import PartnerOfferCard from 'buyside/components/presentation/PartnerOffers/PartnerOfferCard/partnerOfferCard';

import styles from './partnerOffersStyles.scss';

const partnerOffers = [
  {
    adId: '16',
    cta: 'Unlock 20% Off',
    description:
      'Koyfin is a global market analytics platform for researching and understanding markets. From bottom-up fundamentals to top-down macro analysis, our platform, powered by Capital IQ, is trusted by more than 300,000 investors. We offer global coverage of equities, analyst estimates, transcripts, filings, screeners, financials, charting, macro data and custom dashboards.',
    href: 'https://www.koyfin.com/affiliate/sumzero/?via=sumzero',
    logoUrl: '/images/koyfin-logo.svg',
    title: 'Koyfin'
  }
];

const PartnerOffers: React.FC = () => {
  return (
    <>
      <div className={styles.partnerOffersHeader}>
        <h2>Market Analytics Tools</h2>
        <h4>
          Enjoy special offers from our partners on analytics services for your portfolio and
          practices.
        </h4>
      </div>
      <div className={styles.partnerOffersList}>
        {partnerOffers.map(partnerOffer => (
          <PartnerOfferCard key={partnerOffer.title} {...partnerOffer} />
        ))}
      </div>
    </>
  );
};

export default PartnerOffers;
